import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  CanMatch,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { from, Observable } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class RouteGuardService implements CanMatch, CanActivateChild {

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  canMatch(
    _route: Route,
    _segments: UrlSegment[]
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return from(this.checkAccess());
  }

  canActivateChild(
    _childRoute: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return from(this.checkAccess());
  }

  private async checkAccess(): Promise<boolean | UrlTree> {
    let token = this.authService.getAccessToken();
    if (!token) {
      token = await this.authService.refreshAccessToken();
      if (token) {
        await this.authService.fetchAccessProfile(true);
      }
    }

    if (!token) {
      this.authService.logout({ revoke: false });
      return this.router.createUrlTree(['/login']);
    }

    if (!this.authService.currentProfile) {
      await this.authService.ensureProfileCached();
    }

    // Refresh nav/features in the background once access is confirmed.
    void this.authService.fetchNav();
    void this.authService.fetchFeatures();

    return true;
  }
}
